import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AddressService } from "../../../address/services/address.service";
import { IncomeWealthService } from "../../../income-wealth/service/income-wealth.service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { RadioModel } from "../../../shared/model/radio.model";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackInfo } from "../../../shared/service/journey/tracks/model/track-info";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { ProfessionService } from "../../service/profession.service";

export interface AdditionalFields {
  incomeRequired: boolean;
  patrimonyRequired: boolean;
}

@Component({
  selector: "app-origin-income",
  templateUrl: "./origin-income.component.html",
  styleUrls: ["./origin-income.component.scss"],
})
export class OriginIncomeComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "origin-income";
  public selectedItem: string;
  selectedName = "";
  fieldsRequireds: AdditionalFields;
  buttonEnable = false;
  public originIncome = new Array<RadioModel>();
  textAria = "";
  idLabel = "page-origin-income";
  titlePage = "Dados profissionais";
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  dataDomain: RadioModel[];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  idLabelOriginIncome = "idLabelOriginIncome";
  idRadioOriginIncome = "idRadioOriginIncome";
  idButtonOriginIncome = "idButtonOriginIncome";

  constructor(
    public router: NavController,
    private professionalService: ProfessionService,
    private incomeWealthService: IncomeWealthService,
    private addressService: AddressService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    public domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.OriginIncome);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getOriginIncome();
    this.editFieldInvest(
      "origem_renda_codigo",
      "originIncome",
      "professionalData"
    );
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "professional-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "2";
      this.endStage = "4";
    } else {
      this.startStage = track.getIndexPage(this.headerId, path).toString();
      this.endStage = track.getTotalPage(path).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.originIncome;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathOrigemRenda,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathOrigemRenda,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  /* istanbul ignore next */
  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  changeItem(event) {
    if (event) {
      this.buttonEnable = true;
      this.originIncome = this.orderList(this.originIncome, this.selectedItem);
    } else {
      this.buttonEnable = false;
    }
  }

  public clickNext() {
    const save =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "profession"
      ) > -1;

    this.sendAnalyticsFirstView = true;
    this.professionalService.setOriginIncomeName(
      this.selectedName,
      this.selectedItem,
      save
    );
    this.professionalService.setOriginIncome(this.selectedItem, save);

    if (this.fieldsRequireds) {
      this.professionalService.setIncomeRequired(
        this.selectedItem,
        this.fieldsRequireds.incomeRequired,
        save
      );
      this.professionalService.setPatrimonyRequired(
        this.selectedItem,
        this.fieldsRequireds.patrimonyRequired,
        save
      );
    }

    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.originIncome,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  getOriginIncome() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.originIncome = dominios;
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.showRetry = true;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  backPage() {
    this.analyticsEventClique();
    const hasStepAddress =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "cep"
      ) > -1;
    const hasStepMaritalStatus =
      this.journeyService.selectedTrack.track.findIndex(
        (page: TrackInfo) => page.pageId === "marital-status"
      ) > -1;

    if (
      this.journeyService.registratioJourney.data.professionalData
        .originIncomePrevious
    ) {
      this.journeyService.registratioJourney.data.professionalData.originIncome =
        this.journeyService.registratioJourney.data.professionalData.originIncomePrevious;
      this.journeyService.registratioJourney.data.professionalData.originIncomeName =
        this.journeyService.registratioJourney.data.professionalData.originIncomeNamePrevious;
    }

    if (
      this.journeyService.registratioJourney.data.professionalData
        .incomeRequiredPrevious ||
      this.journeyService.registratioJourney.data.professionalData
        .patrimonyRequiredPrevious
    ) {
      this.journeyService.registratioJourney.data.professionalData.incomeRequired =
        this.journeyService.registratioJourney.data.professionalData.incomeRequiredPrevious;
      this.journeyService.registratioJourney.data.professionalData.patrimonyRequired =
        this.journeyService.registratioJourney.data.professionalData.patrimonyRequiredPrevious;
    }

    if (
      this.journeyService.journey === TrackTypes.BASIC ||
      this.journeyService.journey === TrackTypes.BASIC_V2
    ) {
      if (hasStepAddress) {
        if (this.journeyService.journey === TrackTypes.BASIC) {
          return this.backToAddressStep();
        } else {
          return this.back();
        }
      }
      if (hasStepMaritalStatus) {
        return this.backToMaritalStatusStep();
      }
      return this.back();
    } else {
      if (
        this.journeyService.journey === TrackTypes.BASIC_PROFESSIONAL_V2 ||
        this.journeyService.journey === TrackTypes.UPDATE_PROFESSIONAL
      ) {
        this.incomeWealthService.resetDataIncomeWealth();
        this.router.navigateForward(["data", "client-data"]);
      } else {
        this.back();
      }
    }
  }

  backToAddressStep() {
    if (!this.addressService.addressInitalPostCode?.city) {
      return this.router.navigateBack(["address", "city"]);
    }
    if (
      !this.addressService.addressInitalPostCode?.state &&
      this.addressService.addressInitalPostCode?.city
    ) {
      return this.router.navigateBack(["address", "state"]);
    }
    if (
      !this.addressService.addressInitalPostCode?.district &&
      this.addressService.addressInitalPostCode?.city &&
      this.addressService.addressInitalPostCode?.state
    ) {
      return this.router.navigateBack(["address", "district"]);
    }
    if (
      this.addressService.addressInitalPostCode?.district &&
      this.addressService.addressInitalPostCode?.city &&
      this.addressService.addressInitalPostCode?.state
    ) {
      return this.router.navigateBack(["address", "adjunt"]);
    }
  }

  backToMaritalStatusStep() {
    const id =
      this.journeyService.registratioJourney.data?.maritalStatus?.maritalStatus;
    const idConjuge = ["608", "612"];
    const filterId = idConjuge.find((x) => x === id);

    if (!filterId) {
      return this.router.navigateBack(["marital-status", "marital-status"]);
    } else {
      this.back();
    }
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.professionalData
        ?.originIncome &&
      this.journeyService.registratioJourney.data.professionalData
        ?.originIncome !== "0"
    ) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.professionalData.originIncome;
      this.selectedName =
        this.journeyService.registratioJourney.data.professionalData.originIncomeName;
      this.buttonEnable = true;
    }
  }

  clickSaibaMais() {
    this.router.navigateForward("/professional-data/info-data");
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== "") {
      const dataOrder = data.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter((value) => value.key === selectedItem),
        ...dataOrder.filter((value) => value.key !== selectedItem),
      ];
    }
    return data;
  }
}
